import React, { useState, useEffect, useRef } from "react";
import DevelopersLogin from "../../assets/images/developers_login.png";
import DevelopersSmsOtp from "../../assets/images/developers_sms_otp.png";
import DevelopersUat from "../../assets/images/developers_uat.png";
import UatIndustryFoodServicesCourseCode from "../../assets/images/uat_industry_food_services_course_code.png";
import UatProjectDetails from "../../assets/images/uat_project_details.png";
import UatProject from "../../assets/images/uat_project.png";
import Header from "../components/developer_header.jsx";
import Footer from "../components/developer_footer.jsx";
import DevelopersHamburgerMenu from "../../assets/images/developers_hamburger_menu.png";
import ResourceDownloadsSidebar from "../../assets/images/resource_downloads_sidebar.png";
import ResourceStaging from "../../assets//images/resource_staging.png";
import ResourcePolyFinTechUat from "../../assets/images/resource_polyfintech_uat.png";
import StagingCourseCertificate from "../../assets/images/staging_course_certificate.png"
import SandboxCourseCertificateDetails from "../../assets/images/sandbox_course_certificate_details.png";
import CertificationFormStaging from "../../assets/images/certification_form_staging.png"
import CheckoutCart from "../../assets/images/checkout_cart.png";
import CheckoutCartMobileNumber from "../../assets/images/checkout_cart_mobile_number.png";
import CheckoutCartMobileNumberConfirm from "../../assets/images/checkout_cart_mobile_number_confirm.png";
import UatNetsQrWebInspect from "../../assets/images/uat_nets_qr_web_inspect.png";
import UatNetsQrWebConsole from "../../assets/images/uat_nets_qr_web_console.png";
import UatNetsQrWebSuccess from "../../assets/images/uat_nets_qr_web_success.png";
import UatNetsQrWebFail from "../../assets/images/uat_nets_qr_web_fail.png";
import CertificationFormUatNetsQrWebSuccess from "../../assets/images/certification_form_uat_nets_qr_web_success.png";
import CertificationFormUatNetsQrWebTimeout from "../../assets/images/certification_form_uat_nets_qr_web_timeout.png";

const StagingNetsCourseworkLayout = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [activePaymentMethod, setActivePaymentMethod] = useState('nets-qr-web');
  
  // Add state for image modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    imageSrc: ""
  });
  
  // Create refs for each step section
  const step1Ref = useRef(null);
  const step2Ref = useRef(null);
  const step3Ref = useRef(null);
  const step4Ref = useRef(null);
  const step5Ref = useRef(null);
  const step6Ref = useRef(null);
  const step7Ref = useRef(null);
  const step8Ref = useRef(null);
  
  // Function to open image modal
  const openImageModal = (imageSrc) => {
    setImageModal({
      isOpen: true,
      imageSrc: imageSrc
    });
  };
  
  // Function to close image modal
  const closeImageModal = () => {
    setImageModal({
      isOpen: false,
      imageSrc: ""
    });
  };
  
  // Setup intersection observer to detect which step is in view
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "-100px 0px -60% 0px", // Adjust these values as needed
      threshold: 0
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const stepId = parseInt(entry.target.getAttribute('data-step'));
          setActiveStep(stepId);
          
          // Check if this is a payment method section
          const paymentMethod = entry.target.getAttribute('data-payment-method');
          if (paymentMethod && stepId === 6) {
            setActivePaymentMethod(paymentMethod);
          }
        }
      });
    }, options);
    
    // Observe all step elements
    if (step1Ref.current) observer.observe(step1Ref.current);
    if (step2Ref.current) observer.observe(step2Ref.current);
    if (step3Ref.current) observer.observe(step3Ref.current);
    if (step4Ref.current) observer.observe(step4Ref.current);
    if (step5Ref.current) observer.observe(step5Ref.current);
    if (step6Ref.current) observer.observe(step6Ref.current);
    if (step7Ref.current) observer.observe(step7Ref.current);
    if (step8Ref.current) observer.observe(step8Ref.current);
    
    return () => {
      // Clean up observer on component unmount
      if (step1Ref.current) observer.unobserve(step1Ref.current);
      if (step2Ref.current) observer.unobserve(step2Ref.current);
      if (step3Ref.current) observer.unobserve(step3Ref.current);
      if (step4Ref.current) observer.unobserve(step4Ref.current);
      if (step5Ref.current) observer.unobserve(step5Ref.current);
      if (step6Ref.current) observer.unobserve(step6Ref.current);
      if (step7Ref.current) observer.unobserve(step7Ref.current);
      if (step8Ref.current) observer.unobserve(step8Ref.current);
    };
  }, []);

  // Scroll to specific step when clicking on sidebar links
  const scrollToStep = (stepId) => {
    const element = document.getElementById(`step${stepId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile sidebar when selecting a step
    setShowMobileSidebar(false);
  };

  // Scroll to specific payment method within Step 6
  const scrollToPaymentMethod = (method) => {
    setActivePaymentMethod(method);
    setActiveStep(6); // Ensure Step 6 is active
    const element = document.getElementById(`payment-method-${method}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close mobile sidebar after selecting a method
    setShowMobileSidebar(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header/>
      
      {/* Image Modal */}
      {imageModal.isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
          onClick={closeImageModal}
        >
          <div className="relative max-w-[90vw] max-h-[90vh]">
            <button 
              className="absolute top-2 right-2 bg-white rounded-full p-2 text-gray-800 hover:text-gray-600 focus:outline-none"
              onClick={closeImageModal}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <img 
              src={imageModal.imageSrc} 
              alt="Enlarged view"
              className="max-w-full max-h-[85vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking on the image itself
            />
          </div>
        </div>
      )}

      {/* Sticky Breadcrumb - shortened for mobile */}
      <div className="sticky top-0 z-10 bg-gray-100 py-2 sm:py-3 shadow-md">
        <div className="container mx-auto px-4 sm:px-6">
          <p className="text-xs sm:text-sm text-gray-600 text-left truncate">
            <a href="/get-started" className="text-blue-600 hover:underline">Get Started</a> &gt; 
            <a href="/certification-journey" className="text-blue-600 hover:underline"> Certification Journey</a> &gt; 
            <a href="/certification-journey/staging" className="text-blue-600 hover:underline hidden sm:inline"> NETS Certification Process (Staging)</a>
            <a href="/certification-journey/staging" className="text-blue-600 hover:underline inline sm:hidden"> Staging</a> &gt; 
            <span className="hidden sm:inline"> Coursework</span>
            <span className="inline sm:hidden"> Course</span>
          </p>
        </div>
      </div>

      {/* Mobile Step Navigator - only visible on mobile */}
      <div className="md:hidden sticky top-10 z-10 bg-white shadow-md py-2 px-4">
        <div className="flex justify-between items-center">
          <div className="text-sm font-medium">
            Step {activeStep} of 8
          </div>
          <button 
            onClick={() => setShowMobileSidebar(!showMobileSidebar)}
            className="bg-blue-600 text-white px-3 py-1 rounded-md text-sm"
          >
            {showMobileSidebar ? 'Hide Steps' : 'Show Steps'}
          </button>
        </div>
        
        {/* Mobile Sidebar - collapsible */}
        {showMobileSidebar && (
          <div className="mt-3 pb-2 border-t pt-2">
            <ul className="space-y-3 text-sm">
              {[1, 2, 3, 4, 5, 6, 7, 8].map(step => (
                <div key={step}>
                  <li 
                    className={`${activeStep === step ? "text-blue-600 font-medium" : "text-gray-700"} 
                      text-left transition-colors duration-300 cursor-pointer hover:text-blue-500
                      py-1`}
                    onClick={() => scrollToStep(step)}
                  >
                    Step {step} | {step === 1 ? "Consult instructor" :
                                   step === 2 ? "Login" :
                                   step === 3 ? "Create UAT project" :
                                   step === 4 ? "Project details" :
                                   step === 5 ? "Download resources" : 
                                   step === 6 ? "Retrieve txn details" : 
                                   step === 7 ? "Get certified" : "Book certification appointment"}
                  </li>
                  {/* Sub-navigation for Step 6 in mobile */}
                  {step === 6 && activeStep === 6 && (
                    <div className="ml-4 space-y-2 mt-1">
                      <div 
                        className={`${activePaymentMethod === 'nets-qr-web' ? "text-blue-500 font-medium" : "text-gray-600"} text-xs transition-colors duration-300 cursor-pointer hover:text-blue-400 py-1`}
                        onClick={() => scrollToPaymentMethod('nets-qr-web')}
                      >
                        • NETS QR (Web)
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* Main Content - responsive grid */}
      <main className="container mx-auto px-4 sm:px-6 py-6 sm:py-12 grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8 text-left flex-grow">
        {/* Sidebar - hidden on mobile */}
        <aside className="hidden md:block bg-white rounded-lg shadow-md p-4 sm:p-6 text-left md:sticky md:top-16 self-start">
          <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">In this Tutorial</h3>
          <ul className="space-y-4 text-sm text-left">
            <li 
              className={`${activeStep === 1 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(1)}
            >
              Step 1 | Consult the course instructor
            </li>
            <li 
              className={`${activeStep === 2 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(2)}
            >
              Step 2 | Login in to OPENAPIPASS account
            </li>
            <li 
              className={`${activeStep === 3 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(3)}
            >
              Step 3 | Create UAT project
            </li>
            <li 
              className={`${activeStep === 4 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(4)}
            >
              Step 4 | Fill in UAT project details
            </li>
            <li 
              className={`${activeStep === 5 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(5)}
            >
              Step 5 | Download the resources
            </li>
            <li 
              className={`${activeStep === 6 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(6)}
            >
              Step 6 | Retrieving your txn_id and txn_retrieval_ref
            </li>
            {/* Sub-navigation for Step 6 payment methods */}
            {activeStep === 6 && (
              <div className="ml-4 space-y-2 mt-2">
                <div 
                  className={`${activePaymentMethod === 'nets-qr-web' ? "text-blue-500 font-medium" : "text-gray-600"} text-sm transition-colors duration-300 cursor-pointer hover:text-blue-400`}
                  onClick={() => scrollToPaymentMethod('nets-qr-web')}
                >
                  • NETS QR (Web)
                </div>
              </div>
            )}
            <li 
              className={`${activeStep === 7 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(7)}
            >
              Step 7 | Get certified
            </li>
            <li 
              className={`${activeStep === 8 ? "text-blue-600 font-medium" : "text-black"} text-left transition-colors duration-300 cursor-pointer hover:text-blue-500`}
              onClick={() => scrollToStep(8)}
            >
              Step 8 | Book Certificate Validation Appointment
            </li>
          </ul>
        </aside>
        
        {/* Main Section - takes full width on mobile */}
        <section className="col-span-1 md:col-span-2 text-left">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-3 sm:mb-4 text-left">NETS Coursework Certification Process (Staging)</h2>
          <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
            Follow the steps below to get started on your NETS Certification Process in a Staging environment!
          </p>

          {/* Step 1 */}
          <div id="step1" ref={step1Ref} data-step="1" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 1 | Consult the course instructor</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Consult the course instructor to obtain your coursework materials. <br/>The following steps are supporting resources for your coursework.
            </p>
          </div>
          
          {/* Step 2 */}
          <div id="step2" ref={step2Ref} data-step="2" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 2 | Login to OPENAPIPASS account</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Go to the website <a href="https://developers.openapipass.org/homepage" className="text-blue-600 hover:underline break-all">https://developers.openapipass.org/homepage</a> to log in to your developer account by entering your phone number. Click on 'Get SMS OTP'. On receiving the SMS OTP, click on 'Proceed' button.
            </p>
            
            <div className="flex flex-col items-center sm:items-start space-y-4 mb-4 sm:mb-6">
              <img
                src={DevelopersLogin}
                alt="SHA256 Authentication"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersLogin)}
              />
              <img
                src={DevelopersSmsOtp}
                alt="SHA256 Authentication"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersSmsOtp)}
              />
            </div>
          </div>

          {/* Step 3 */}
          <div id="step3" ref={step3Ref} data-step="3" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 3 | Create UAT project</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once logged in, click on 'UAT'.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={DevelopersUat}
                alt="Testing Payment Flows"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersUat)}
              />
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once clicked, you would be prompted to this page, click on 'Apply Course Code' under the Food Services Industry.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={UatIndustryFoodServicesCourseCode}
                alt="Testing Payment Flows"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(UatIndustryFoodServicesCourseCode)}
              />
            </div>
          </div>

          {/* Step 4 */}
          <div id="step4" ref={step4Ref} data-step="4" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 4 | Fill in UAT project details</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Fill in the details like in the image below. <br/>
              Note: The project name can be any name, the URL can also be left blank for this guide. The voucher code will be provided by your course instructor.
            </p>

            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={UatProjectDetails}
                alt="Testing Payment Flows"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(UatProjectDetails)}
              />
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once created, you would be able to see your project like the screen below: <br/>
              Note: You can click 'View More' to view the project credentials.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={UatProject}
                alt="Testing Payment Flows"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(UatProject)}
              />
            </div>
          </div>

          {/* Step 5 */}
          <div id="step5" ref={step5Ref} data-step="5" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 5 | Download the resources</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Click on menu icon at the top left corner of the webpage.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={DevelopersHamburgerMenu}
                alt="Testing Payment Flows"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(DevelopersHamburgerMenu)}
              />
            </div>

            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Click on 'Resources', navigate to 'Downloads'.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img 
                src={ResourceDownloadsSidebar}
                alt="Testing Payment Flows"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(ResourceDownloadsSidebar)}
              />
            </div>

            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-justify">
              Do note, if you are downloading PolyFinTech Skills Development Resources, go to UAT folder in the left image. Else, if you are downloading school coursework resources, go to Staging environment folder in the right image. For the passcode, you may check with your course instructor.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={ResourcePolyFinTechUat}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(ResourcePolyFinTechUat)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">OR</span>
            <img
              src={ResourceStaging}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(ResourceStaging)}
            />
          </div>
          </div>

          {/* Step 6 */}
          <div id="step6" ref={step6Ref} data-step="6" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 6 | Retrieving your txn_id and txn_retrieval_ref</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After completing your NETS coursework, you need to retrieve transaction details to get certified. The process varies depending on what coursework you started on. 
              For Staging environment, only NETS QR payment method is available for certification.
            </p>
            
            {/* NETS QR Web Section */}
            <div id="payment-method-nets-qr-web" className="mb-8 scroll-mt-32">
              <h4 className={`text-md font-semibold mb-3 text-left transition-all duration-300 ${
                activePaymentMethod === 'nets-qr-web' 
                  ? 'text-blue-600 bg-blue-50 px-3 py-2 rounded-md border-l-4 border-blue-600' 
                  : 'text-blue-600'
              }`}>NETS QR (Web)</h4>

              <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
                Once you have completed the NETS QR Web Add To Cart coursework, go back to the homepage.  Ensure that you are in the page like image below, then click 'Checkout' button.
              </p>
            
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={CheckoutCart}
                alt="CheckoutCart"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CheckoutCart)}
              />
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once you have clicked on 'Checkout' button, you would be prompted to a page like the image below. Put in your phone number and proceed with payment.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={CheckoutCartMobileNumber}
                alt="CheckoutCartMobileNumber"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CheckoutCartMobileNumber)}
              />
              <img
                src={CheckoutCartMobileNumberConfirm}
                alt="CheckoutCartMobileNumberConfirm"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CheckoutCartMobileNumberConfirm)}
              />
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After you have generated the QR code, do not pay first. The txn_id and txn_retrieval_ref only appear in the console if the QR code is displayed but not scanned. To view them, right-click on the page and select 'Inspect'.
            </p>
              <img
                src={UatNetsQrWebInspect}
                alt="UatNetsQrWebInspect"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(UatNetsQrWebInspect)}
              />
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once you have clicked 'Inspect', click on the 'Console' tab. Look for the response object that is logged and expand it. That is where you are able to obtain your txn_retrieval_ref number and txn_id. 
            </p>
              <img
                src={UatNetsQrWebConsole}
                alt="UatNetsQrWebConsole"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(UatNetsQrWebConsole)}
              />
            <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Successful Payment</h5>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After you have obtained your payment success txn_id and txn_retrieval_ref, make payment with the TWallet NETS Simulator Payment Android App. Ensure transaction is successful, Whatsapp notifications received and the green tick appears like the image below.
            </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={UatNetsQrWebSuccess}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(UatNetsQrWebSuccess)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
            <img
              src={CertificationFormUatNetsQrWebSuccess}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(CertificationFormUatNetsQrWebSuccess)}
            />
          </div>
            <h5 className="text-md font-semibold text-gray-800 mb-3 mt-6 text-left">Unsuccessful Payment(Timeout)</h5>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              For payment timeout txn_id and txn_retrieval_ref, you can repeat the steps above but instead of scanning, you will need to wait for 5 minutes for payment timeout and the red cross will appear like the image below.
            </p>
            <p className="text-sm sm:text-base text-red-600 mb-4 sm:mb-6 text-left">
              <b>Note: Do not navigate away, minimize browser or refresh the page. Remain on the QR code page for 5 minutes until the red cross is shown. </b>
            </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-4 items-center justify-center">
            <img
              src={UatNetsQrWebFail}
              alt="NETS Download Folder Sandbox"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(UatNetsQrWebFail)}
            />
            <span className="text-gray-600 font-bold text-sm sm:text-base sm:flex-shrink-0">➜</span>
            <img
              src={CertificationFormUatNetsQrWebTimeout}
              alt="NETS Download Folder PayTech"
              className="shadow-md rounded-md w-full sm:w-[calc(50%-2rem)] cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => openImageModal(CertificationFormUatNetsQrWebTimeout)}
            />
          </div>
            </div>
          </div>

          {/* Step 7 */}
          <div id="step7" ref={step7Ref} data-step="7" className="scroll-mt-24 mb-6 sm:mb-10">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 7 | Get Certified</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once you have retrieved the txn_id and txn_retrieval_ref from Step 6, you can proceed with the certification process.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={StagingCourseCertificate}
                alt="Get Certified Staging"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(StagingCourseCertificate)}
              />
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Click on 'Get Course Certificate', input the full name to be displayed in the certificate and provide your school email for verification purposes.
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={SandboxCourseCertificateDetails}
                alt="Certificate Form"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(SandboxCourseCertificateDetails)}
              />
            </div>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              Once you've entered your full name and school email,  fill in the txn_id and txn_retrieval_ref. In the screenshot below, since "NETS QR Web" was selected, you need to provide the NETS QR txn_id and txn_retrieval_ref.
              <br />
              Do Note that only NETS QR Web is available to get certified in Staging environment. NETS Click and eNETS certification in Staging environment coming soon!
            </p>
            <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
              <img
                src={CertificationFormStaging}
                alt="Certificate Details"
                className="shadow-md rounded-md w-full max-w-md cursor-pointer hover:opacity-90 transition-opacity"
                onClick={() => openImageModal(CertificationFormStaging)}
              />
            </div>
          </div>

          {/* Step 8 */}
          <div id="step8" ref={step8Ref} data-step="8" className="scroll-mt-24 mb-8 sm:mb-12">
            <h3 className="text-lg font-semibold text-gray-800 mb-3 sm:mb-4 text-left">Step 8 | Book Certificate Validation Appointment</h3>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              After successfully submitting your certification application, you would have to book an appointment with us to verify that you have met all requirements and that your implementation meets the certification standards.
            </p>
            <div className="mb-4 sm:mb-6 text-left">
              <a 
                href="https://docs.google.com/forms/d/e/1FAIpQLSe2LyW45OXhFpjGCA__1mnT5ps13emqQw2pUAbFtpMi-Edvkw/viewform" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-blue-600 hover:bg-blue-700 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-md text-sm sm:text-base font-medium transition duration-300 inline-block"
              >
                Book Appointment
              </a>
            </div>
            


            <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6">
              <h4 className="text-md font-semibold text-green-800 mb-2 text-left">Important Notes</h4>
              <ul className="list-disc list-inside text-sm text-green-700 space-y-2">
                <li>Check your email regularly (including spam/junk folders) for the confirmation of your preferred session and location.</li>
                <li>Once we confirmed that you are eligible, your digital certificate will be sent to the email address you provided at Step 7.</li>
                <li>Digital certificates are provided in PDF format.</li>
              </ul>
            </div>

            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 text-left">
              <strong>Congratulations!</strong> You have completed all the required steps for NETS UAT certification. Your certificate will serve as proof of your competency in implementing NETS payment solutions in UAT environment.
            </p>
          </div>

          <div className="mt-6 sm:mt-10 text-left">
            <a 
              href="/certification-journey/staging" 
              className="bg-blue-600 hover:bg-blue-700 text-white py-2 sm:py-3 px-4 sm:px-6 rounded-md text-sm sm:text-base font-medium transition duration-300"
            >
              Back to Staging Certification
            </a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default StagingNetsCourseworkLayout;